var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0001 29.4852L36.9658 39.5839C37.7621 40.3907 37.7292 41.6974 36.8934 42.4632L36.3112 42.9967C35.5229 43.7191 34.3058 43.6936 33.5484 42.9389L21.4409 30.8744C20.6492 30.0855 20.6577 28.8008 21.4598 28.0224L33.6862 16.1581C34.4695 15.398 35.7175 15.4063 36.4907 16.1767L37.134 16.8177C37.9257 17.6066 37.9172 18.8913 37.1151 19.6697L27.0001 29.4852Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.60636ca7f6e7e9f73a22c93230076bfa.svg";
export { ForwardRef as ReactComponent };